import type { Configuration as MsalConfiguration } from "@azure/msal-browser";
import type { AppEnvironment } from "@freightsimple/api-runtime/appEnvironment";

// Hubble's MSAL config keys off the shared deployment environment.
export type HubbleEnvironment = AppEnvironment;

const azureClientIds: Record<HubbleEnvironment, string> = {
  local: "0a3192a3-2d90-41da-94a7-2f1237117a28",
  preprod: "f01f2f25-643f-4686-9e8d-ba90136afeee",
  demo: "886f1e1c-50b3-4f80-95eb-85e9063b7dd2",
  production: "b6ec59f0-e106-4c3c-a856-15a1b63410b9",
};

const tenantId = "f5f70d62-2296-4bcd-a80e-24b44a7db656";

function getAzureClientId(environment: HubbleEnvironment): string {
  return azureClientIds[environment];
}

export function getMsalConfig(
  environment: HubbleEnvironment,
): MsalConfiguration {
  const clientId = getAzureClientId(environment);
  return {
    auth: {
      clientId,
      authority: `https://login.microsoftonline.com/${tenantId}/`,
      // MSAL v5 silent token acquisition uses a BroadcastChannel-based
      // "redirect bridge" — it opens this URL in a hidden iframe expecting
      // broadcastResponseToMainFrame() to post the auth response back to
      // the parent. Pointing redirectUri at the full Hubble app makes that
      // iframe load index.tsx, MSAL throws block_iframe_reload inside the
      // iframe, and the parent times out 10s later with redirect_bridge_timeout.
      // /auth-redirect.html is a dedicated minimal page (see
      // frontend/apps/hubble/auth-redirect.html and src/authRedirect.tsx)
      // that exists only to call broadcastResponseToMainFrame(). The same
      // URI handles interactive redirect logins — the bridge function
      // detects redirect flows and forwards the response to the app.
      redirectUri: `${window.location.origin}/auth-redirect.html`,
      postLogoutRedirectUri: "/",
    },
    cache: {
      cacheLocation: "localStorage",
    },
  };
}

export function getLoginRequest(environment: HubbleEnvironment) {
  return {
    scopes: [`${getAzureClientId(environment)}/.default`],
  };
}
